module.exports = "<div id=\"infoBox\" class=\"noscrollbar info-box\">\n  <strong><%= content %></strong>\n  <% if (type === 'address') { %>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <button data-ng-cloak data-ng-show=\"reportFeature\" ng-controller=\"ReportCtrl\" data-ng-click=\"openReport()\" class=\"btn btn-block btn-primary\">\n        Generate Report\n      </button>\n    </div>\n  </div>\n  <% } %>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./client/templates/addressWindow.html
// module id = E8VS
// module chunks = 1